// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 774 ? "72a92d46" : chunkId) + "." + {"478":"1739af19df60314f","774":"98e37dc5754e9808"}[chunkId] + ".js";
};